import { initializeApp,getApps } from "firebase/app";
import { getToken, onMessage } from "firebase/messaging";
import { getMessaging } from "firebase/messaging";
const VITE_APP_VAPID_KEY = process.env.VITE_APP_VAPID_KEY;
//Firebase Config values imported from .env file

const firebaseConfig = {
  apiKey: "AIzaSyDzlogAFX7w_1wvqV5SGcDVSG851qahCfM",
  authDomain: "pushnotification-c511b.firebaseapp.com",
  projectId: "pushnotification-c511b",
  storageBucket: "pushnotification-c511b.firebasestorage.app",
  messagingSenderId: "139412557756",
  appId: "1:139412557756:web:f88a6a75d245d97362e5b9"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyDI6JiDKWjn9vzNsYoz8rx_0ZRUFKZg21U",
//   authDomain: "orderthat-4300d.firebaseapp.com",
//   projectId: "orderthat-4300d",
//   storageBucket: "orderthat-4300d.firebasestorage.app",
//   messagingSenderId: "983883511988",
//   appId: "1:983883511988:web:fa85dff909225a4b4cffe1"
// };

// Initialize Firebase
let msg;
// const app = initializeApp(firebaseConfig);
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
// Messaging service
if ("serviceWorker" in navigator) {
  msg = getMessaging(app);
}
export const  messaging = msg;
// Request permission for notifications
export const requestPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: VITE_APP_VAPID_KEY, // Get from Firebase Console
      });
      localStorage.setItem("fcm_token", token);
      console.log("FCM Token:", token);
      return token;
    } else {
      console.log("Notification permission denied");
    }
  } catch (error) {
    console.error("Error getting notification permission:", error);
  }
};

// Handle incoming messages
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("FCM Message received:", payload);
      resolve(payload);
    });
  });